import React from "react";
import { Text, VStack, Box, Heading } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import BlockchainSvg from "../images/icons/blockchain"
import MobileDevSvg from "../images/icons/mobile-dev"
import UxDesignSvg from "../images/icons/ux-design"
import WebDevSvg from "../images/icons/web-dev"
import Tag from "./Tag"

const copy = {
  callout: "What we do",
  heading: "We offer a complete range of bespoke design and development services to help you turn your ideas into digital masterpieces",
  services: [
    {
      icon: WebDevSvg(),
      title: "Web development",
      description: "We use cutting-edge web development technologies to help our clients fulfill their business goals through functional, reliable solutions."
    },
    {
      icon: UxDesignSvg(),
      title: "User experience & design",
      description: "Our complete web design services will bring your ideas to life and provide you with a sleek, high-performing product that elevates your business."
    },
    {
      icon: MobileDevSvg(),
      title: "Mobile app development",
      description: "Our extensive mobile development experience allows us to create custom native and cross-platform iOS and Android mobile solutions for our clients."
    },
    {
      icon: BlockchainSvg(),
      title: "Blockchain solutions",
      description: "We conduct market research to determine the optimal blockchain-based solutions to help you grow your company and achieve your business goals."
    }
  ]
}

const Services = () => (
  <div id="services-section">
    <FullScreenSection
      alignContent="flex-start"
      justifyContent="center"
      alignItems="flex-start"
      width="100%"
      flexDirection="column"
      minHeight="30vh"

    >
      <VStack
        alignContent="flex-start"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={10}
        m={8}

      >
        <Tag>{copy.callout}</Tag>

        <Heading  >{copy.heading}</Heading>

        <Box
          display="grid"
          gridTemplateColumns="repeat(4,minmax(0,1fr))"
          gridGap={8}
        >
          {copy.services.map(({ icon, title, description }, index) => (
            <VStack
              alignContent="flex-start"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={6}
              key={index}
            >
              <Box width="64px" maxWidth="64px">{icon}</Box>
              <Heading as='h4' size='md'>{title}</Heading>
              <Text>{description}</Text>
            </VStack>
          ))}

        </Box>
      </VStack>
    </FullScreenSection>
  </div>
);

export default Services;
